module.exports = __webpack_public_path__ + "img/Visual.24fbf5aa.png";